import { render, staticRenderFns } from "./ArrangeHeader.vue?vue&type=template&id=63e2d894&"
import script from "./ArrangeHeader.vue?vue&type=script&lang=js&"
export * from "./ArrangeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports